import '../styles/separation.css'

function Separation2() {
    return (
        <div id="separation1_displayx">
            <div id='separation1x'>
                <hr id='separation1_x'/>
                <hr id='separation2_x'/>
            </div>
        </div>
    )
}

export default Separation2